// extracted by mini-css-extract-plugin
export default {"group":"SMLDeviceToggle_group__ahQFi","option":"SMLDeviceToggle_option__WNAWu","selected":"SMLDeviceToggle_selected__8PJal"};